module.exports = __webpack_public_path__ + "static/media/jp.22e3b3a4.svg";